'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconTriangleTwoLinesHorizontal, iconTriangleTwoLinesHorizontalTag } from '@ni/nimble-components/dist/esm/icons/triangle-two-lines-horizontal';
import { wrap } from '../../utilities/react-wrapper';

export type { IconTriangleTwoLinesHorizontal };
export { iconTriangleTwoLinesHorizontalTag };
export const NimbleIconTriangleTwoLinesHorizontal = wrap(IconTriangleTwoLinesHorizontal);